/* simotas — global.js */
(function () {
  'use strict';

  /* ---------- Collection filters ---------- */
  var filterForm = document.getElementById('FilterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      // auto-apply on checkbox / radio / select; price fields use the Go button
      if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) {
        filterForm.submit();
      }
    });
  }
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect && filterForm) {
    sortSelect.addEventListener('change', function () { filterForm.submit(); });
  }

  var sidebar = document.querySelector('[data-collection-sidebar]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) {
      if (sidebar) sidebar.classList.toggle('is-open');
      return;
    }
    if (sidebar && sidebar.classList.contains('is-open') &&
        !e.target.closest('[data-collection-sidebar]')) {
      sidebar.classList.remove('is-open');
    }
  });

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    var format = window.moneyFormat || '€{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Header search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-header-search]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) searchBar.querySelector('input[type="search"], input[name="q"]').focus();
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refreshCart() {
    return fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function renderDrawer(cart) {
    var body = drawer && drawer.querySelector('[data-cart-drawer-body]');
    var footer = drawer && drawer.querySelector('[data-cart-drawer-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p class="cart-drawer__empty-title">Jūsų krepšelis tuščias</p>' +
          '<p class="cart-drawer__empty-sub">Įsidėkite prekių ir jos atsiras čia.</p>' +
          '<a class="btn btn--primary btn--pill" href="/collections/all">Pradėti apsipirkti</a>' +
        '</div>';
      if (footer) footer.hidden = true;
      return;
    }

    var html = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '';
      return (
        '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
          '<div class="cart-drawer__item-media">' + img + '</div>' +
          '<div class="cart-drawer__item-info">' +
            '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
            (item.variant_title ? '<div class="cart-drawer__item-price">' + item.variant_title + '</div>' : '') +
            '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-drawer__item-qty">' +
              '<div class="qty-input">' +
                '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-value readonly>' +
                '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-line-remove>Pašalinti</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    body.innerHTML = html;
    if (footer) {
      footer.hidden = false;
      var subtotal = footer.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
    }
    updateFreeShipping(cart);
  }

  function updateFreeShipping(cart) {
    var bar = drawer && drawer.querySelector('[data-freeship]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) { bar.hidden = true; return; }
    bar.hidden = false;
    var subtotal = cart.items_subtotal_price;
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    var fill = bar.querySelector('[data-freeship-fill]');
    var msg = bar.querySelector('[data-freeship-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (subtotal >= threshold) {
        msg.innerHTML = '🎉 Jums priklauso <strong>nemokamas pristatymas!</strong>';
        bar.classList.add('is-complete');
      } else {
        msg.innerHTML = 'Iki nemokamo pristatymo trūksta <strong>' + formatMoney(threshold - subtotal) + '</strong>';
        bar.classList.remove('is-complete');
      }
    }
  }

  function changeLine(key, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var lineEl = e.target.closest('[data-line-key]');
    if (!lineEl) return;
    var key = lineEl.getAttribute('data-line-key');
    var qtyInput = lineEl.querySelector('[data-qty-value]');

    if (e.target.closest('[data-qty-change]')) {
      var delta = parseInt(e.target.closest('[data-qty-change]').getAttribute('data-qty-change'), 10);
      var next = Math.max(0, parseInt(qtyInput.value, 10) + delta);
      changeLine(key, next);
    }
    if (e.target.closest('[data-line-remove]')) {
      changeLine(key, 0);
    }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Dedama…'; }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart.');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn || e.target.closest('[data-line-key]')) return;
    var wrap = stepBtn.closest('.qty-input');
    var input = wrap.querySelector('input');
    var delta = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    var main = gallery.querySelector('[data-gallery-main] img');
    main.src = thumb.getAttribute('data-image-src');
    main.srcset = '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ---------- Variant selection: update price / availability ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var productJsonEl = document.querySelector('[data-product-json="' + form.getAttribute('data-product-id') + '"]');
    if (!productJsonEl) return;
    var product = JSON.parse(productJsonEl.textContent);

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-select]')) return;
      var selected = Array.from(form.querySelectorAll('[data-option-select]')).map(function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[type="submit"]');
      var priceEl = document.querySelector('[data-product-price]');
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? btn.getAttribute('data-atc-text') : 'Išparduota';
        }
      } else if (btn) {
        btn.disabled = true;
        btn.textContent = 'Nepasiekiama';
      }
    });
  });

  /* ---------- Initial cart count ---------- */
  refreshCart();
})();
